import { BlockRuleFormValues } from './components/block-rule-form';

export function toMutationInput(values: BlockRuleFormValues) {
    const ttlHours = values.ttlHours ? parseInt(values.ttlHours, 10) : undefined;
    return {
        name: values.name,
        operator: values.operator,
        ipAddress: values.ipAddress || null,
        email: !values.emailRegex ? (values.email || null) : null,
        emailRegex: values.emailRegex || null,
        bin: !values.binRegex ? (values.bin || null) : null,
        binRegex: values.binRegex || null,
        isPermanent: values.isPermanent,
        ttlHours: values.isPermanent ? undefined : ttlHours,
        // Fields not in the form UI — keep null/defaults
        customerId: null,
        paymentId: null,
        pan: null,
        panRegex: null,
        autoCreated: false,
        metadata: null,
    };
}
